if (!BEditor.EditorsManager)
{
  BEditor.EditorsManager = new EditorsManager();
}


export default function EditorsManager ()
{
  const pThis = this;

  pThis.getBrowserIsValid = getBrowserIsValid;
  pThis.setWaitScore = setWaitScore;
  pThis.checkIfAnyEditorExists = checkIfAnyEditorExists;
  pThis.checkIfEditorExists = checkIfEditorExists;
  pThis.checkIfAllEditorsStarted = checkIfAllEditorsStarted;
  pThis.checkIfAllEditorsLoaded = checkIfAllEditorsLoaded;
  pThis.checkIfAllEditorsReady = checkIfAllEditorsReady;
  pThis.checkIfAllEditorsStay = checkIfAllEditorsStay;
  pThis.createEditor = createEditor;
  pThis.getPageGlobalStyles = getPageGlobalStyles;
  pThis.validateBeforePublish = validateBeforePublish;
  pThis.saveAllEditData = saveAllEditData;
  pThis.safeSaveData = safeSaveData;
  pThis.getEditorById = getEditorById;
  pThis.initAllEditors = initAllEditors;
  pThis.getIsEditorsInViewMode = getIsEditorsInViewMode;
  pThis.setIsEditorsInViewMode = setIsEditorsInViewMode;
  pThis.validateEmptyData = validateEmptyData;
  pThis.hookupPageValidation = hookupPageValidation;
  pThis.unloadAllEditors = unloadAllEditors;
  pThis.unloadPage = unloadPage;
  pThis.getStartedEditors = function() { return startedEditors; };

  pThis.startEditing = onStartEditing;
  pThis.stopEditing = onStopEditing;

  pThis.pEditors = [];
  pThis.Sys = {};

  pThis.EditorStarted = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorStarted' });
  pThis.EditorStopped = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorStopped' });
  pThis.EditorResized = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorResized' });
  pThis.EditorBlured = BEditor.eventHandlers.createHandlers(pThis, { id: 'EditorBlured' });


  let topWin = BEditor.environment.topWindow,
      isIE = BEditor.browser.isIE,
      $winContent = getRuntimeDefaultWindow(),
      winLocationHref = $winContent.location.href,
      winLocationDomain = winLocationHref.replace(/^(https?\:\/\/[^\/\:]+)(\/|\:)?.*$/i, '$1'),
      saveAllDataAttempts,
      saveAllDataAttemptTimeout = null,
      isEditorsInViewMode = false,
      validateHTMLConfig = null,
      isLocalToolbar = false,
      startedEditors = {};

  let browserForEditor = null;

  let lastStartedEditor;


  function getRuntimeDefaultWindow()
  {
    return (topWin.contentarea) ? topWin.contentarea : window;
  }

  function getBrowserIsValid ()
  {
    if (browserForEditor === null)
    {
      if (BEditor.browser.isIE && BEditor.browser.isIE >= 10)
      {
        browserForEditor = (document.designMode && document.selection &&
                            ((typeof (document.selection.createRange)) === 'object' || (typeof (document.selection.createRange)) === 'function') &&
                            ((typeof (document.execCommand)) === 'object' || (typeof (document.execCommand)) === 'function') &&
                            ((typeof (document.queryCommandEnabled)) === 'object' || (typeof (document.queryCommandEnabled)) === 'function') &&
                            ((typeof (document.queryCommandIndeterm)) === 'object' || (typeof (document.queryCommandIndeterm)) === 'function') &&
                            ((typeof (document.queryCommandState)) === 'object' || (typeof (document.queryCommandState)) === 'function') &&
                            ((typeof (document.queryCommandSupported)) === 'object' || (typeof (document.queryCommandSupported)) === 'function') &&
                            ((typeof (document.queryCommandValue)) === 'object' || (typeof (document.queryCommandValue)) === 'function'));
      }
      else if (BEditor.browser.isGecko || BEditor.browser.isWebKit)
      {
        browserForEditor = (document.designMode && (typeof (window.getSelection)) === 'function' &&
                            (typeof (window.getSelection().getRangeAt)) === 'function' &&
                            (typeof (window.getSelection().removeAllRanges)) === 'function' &&
                            (typeof (document.createRange)) === 'function' &&
                            (typeof (document.execCommand)) === 'function' &&
                            (typeof (document.queryCommandEnabled)) === 'function' &&
                            (typeof (document.queryCommandState)) === 'function' &&
                            (typeof (document.queryCommandValue)) === 'function');
      }
      else
      {
        browserForEditor = false;
      }
    }

    return browserForEditor;
  }


  function setWaitScore (inContainer)
  {
    let html = inContainer.innerHTML,
        htmlLength = html.length,
        gadgetCounter,
        imgCounter,
        iframeCounter,
        objectCounter,
        embedCounter,
        flashCounter,
        score;

    gadgetCounter = html.match(/sysArtBoxModuleContainer_/g);
    gadgetCounter = gadgetCounter ? gadgetCounter.length : 0;

    imgCounter = inContainer.getElementsByTagName('IMG');
    imgCounter = imgCounter ? imgCounter.length : 0;

    iframeCounter = inContainer.getElementsByTagName('IFRAME');
    iframeCounter = iframeCounter ? iframeCounter.length : 0;

    objectCounter = inContainer.getElementsByTagName('OBJECT');
    objectCounter = objectCounter ? objectCounter.length : 0;

    embedCounter = inContainer.getElementsByTagName('EMBED');
    embedCounter = embedCounter ? embedCounter.length : 0;

    flashCounter = html.match(/\.swf/ig);
    flashCounter = flashCounter ? flashCounter.length : 0;

    score = htmlLength / 1000 + gadgetCounter * 173 + imgCounter * 7 + iframeCounter * 73 + objectCounter * 37 + embedCounter * 37 + flashCounter * 37;

    return ((score < 7000) ? Math.round(score) : 7000);
  }


  function checkIfAnyEditorExists ()
  {
    for (let i = BEditor.pEditors.length; i--;)
    {
      if (BEditor.pEditors[i] && BEditor.pEditors[i].editor && BEditor.pEditors[i].editor.isObjExist === true)
      {
        return true;
      }
    }

    return false;
  }


  function checkIfEditorExists (targetWindow)
  {
    const variableWindow = targetWindow || getRuntimeDefaultWindow(),
          elements = variableWindow.document.getElementsByTagName('IFRAME');

    for (let i = elements.length; i--;)
    {
      if (elements[i].id.indexOf('idEditorIFrame_') === 0)
      {
        return true;
      }
    }

    return false;
  }


  function checkIfAllEditorsStarted ()
  {
    return checkAllEditorsValidity(0);
  }


  function checkIfAllEditorsLoaded ()
  {
    return checkAllEditorsValidity(1);
  }


  function checkIfAllEditorsReady ()
  {
    return checkAllEditorsValidity(2);
  }


  function checkAllEditorsValidity(state)
  {
    let allEditorsValid = true;

    for (let i = 0; i < pThis.pEditors.length; i++)
    {
      if (!pThis.pEditors[i] || !pThis.pEditors[i].editor || pThis.pEditors[i].editor.isObjValid === false || pThis.pEditors[i].editor.isObjValid < state)
      {
        allEditorsValid = false;
        break;
      }
    }

    return allEditorsValid;
  }


  function checkIfAllEditorsStay ()
  {
    let allEditorsStay = false;

    for (i = 0; i < pThis.pEditors.length; i++)
    {
      if (pThis.pEditors[i].editor.isObjStay)
      {
        allEditorsStay = true;
        break;
      }
    }

    return allEditorsStay;
  }


  function onStartEditing (pSender, args = {})
  {
    let params = args.params || {};

    params.extParameters.isInToEditor = true;
    params.extParameters.isContentGadget = true;

    lastStartedEditor = BEditor.EditorsManager.createEditor(
      params.editorId || 'ContentGadget',
      params.idIn,
      params.idOut,
      params.blankPageURL,
      params.displayMode,
      params.pToolbar,
      params.pToolbarConfig,
      params.autoStart,
      params.autoFocus,
      params.minEditorHeight,
      params.mainIdForBodyStyles,
      params.mainClassForBodyStyles,
      params.extParameters
    );

    lastStartedEditor.initEditor();
  }


  function onStopEditing(pSender, args)
  {
    if (args && args.editor)
    {
      args.editor.stopEdit();
    }
    else
    {
      lastStartedEditor.stopEdit();
    }
  }


  function createEditor (editorId, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters)
  {
    let i,
        isLocalToolbar = !!(extParameters.isLocalToolbar),
        isReactComponentEditor = !!(extParameters.isReactComponentEditor),
        hasMultiEditorExtParam = !!extParameters.isMultiEditor;

    pToolbar = pToolbar || BEditor.ToolbarsManager.toolbar;

    setWindowVariables();
    BEditor.domHandlers.addHandler($winContent, 'unload', unloadAllEditors);

    pThis.isToolbarForHeader = false;
    pThis.isToolbarForFooter = false;

    if (!topWin.adminpanel)
    {
      pToolbarConfig = 'EditorToolbarPublicConfig';
      validateHTMLConfig = EditorValidateHTMLConfig;
    }
    else if (!isLocalToolbar && topWin.contentarea)
    {
      if (editorId === 'editDescription')
      {
        pToolbarConfig = 'EditorToolbarEventConfig';
      }
      else if (topWin.contentarea.ComposeEmailObj || (pToolbarConfig && pToolbarConfig.name && pToolbarConfig.name === 'EditorToolbarComposeEmailConfig'))
      {
        pToolbarConfig = EditorToolbarComposeEmailConfig;
      }
    }

    if (!pToolbarConfig)
    {
      pToolbarConfig = isLocalToolbar ? (isReactComponentEditor ? 'EditorToolbarCardsLocalConfig' : 'EditorToolbarLocalConfig') : 'EditorToolbarDefaultConfig';
    }

    BEditor.Config.Ready.addHandler(function () { BEditor.ToolbarsManager.configurateToolbar(pToolbarConfig, isLocalToolbar); });

    for (i = 0; i < pThis.pEditors.length; i++)
    {
      if (pThis.pEditors[i].id === editorId)
      {
        pThis.pEditors[i].idIn = idIn;
        pThis.pEditors[i].idOut = idOut;
        pThis.pEditors[i].editor.reInitEditor(editorId, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters);
        pThis.pEditors[i].contentIFrameName = pThis.pEditors[i].editor.editorContentIFrameName;
        return pThis.pEditors[i].editor;
      }
    }

    for (i = 0; i < pThis.pEditors.length; i++)
    {
      if (pThis.pEditors[i].editor.isObjDeleted && pThis.pEditors[i].id.indexOf('_ContentGadgetEditor') !== -1 && editorId.indexOf('_ContentGadgetEditor') !== -1)
      {
        pThis.pEditors[i].id = editorId;
        pThis.pEditors[i].idIn = idIn;
        pThis.pEditors[i].idOut = idOut;
        pThis.pEditors[i].editor.reInitEditor(editorId, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters);
        pThis.pEditors[i].contentIFrameName = pThis.pEditors[i].editor.editorContentIFrameName;
        return pThis.pEditors[i].editor;
      }
    }

    i = pThis.pEditors.length;
    pThis.pEditors[i] = {};
    pThis.pEditors[i].id = editorId;
    pThis.pEditors[i].idIn = idIn;
    pThis.pEditors[i].idOut = idOut;

    let isComposeEmailEditor = window.EditorToolbarComposeEmailConfig && pToolbarConfig.name === EditorToolbarComposeEmailConfig.name;

    if (displayMode === 'edit' && (isComposeEmailEditor || hasMultiEditorExtParam)) //editorId != 'editDescription' && idIn == 'idPrimaryContentBlock1Content')
    {
      pThis.pEditors[i].editor = new BEditor.MultiEditor(pThis, editorId, i, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters);
      pThis.pEditors[i].editor.EditorStarted.addHandler(onEditorStarted);
      pThis.pEditors[i].editor.EditorStopped.addHandler(onEditorStopped);
      pThis.pEditors[i].editor.EditorResized.addHandler(onEditorResized);
      pThis.pEditors[i].editor.EditorBlured.addHandler(onEditorBlured);
      pThis.pEditors[i].type = 'MultiEditor';
    }
    else
    {
      pThis.pEditors[i].editor = new BEditor.Editor(pThis, editorId, idIn, idOut, blankPageURL, displayMode, pToolbar, pToolbarConfig, autoStart, autoFocus, minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters);
      pThis.pEditors[i].editor.EditorStarted.addHandler(onEditorStarted);
      pThis.pEditors[i].editor.EditorStopped.addHandler(onEditorStopped);
      pThis.pEditors[i].editor.EditorResized.addHandler(onEditorResized);
      pThis.pEditors[i].editor.EditorBlured.addHandler(onEditorBlured);
      pThis.pEditors[i].type = 'SingleEditor';
      pThis.pEditors[i].contentIFrameName = pThis.pEditors[i].editor.editorContentIFrameName;
    }

    return pThis.pEditors[i].editor;
  }


  function onEditorStarted(sender, args)
  {
    args.editor = sender;
    startedEditors[sender.getEditorId()] = sender;

    pThis.EditorStarted.fireHandlers(args);
  }


  function onEditorStopped(sender, args)
  {
    args.editor = sender;
    delete startedEditors[sender.getEditorId()];

    pThis.EditorStopped.fireHandlers(args);
  }


  function onEditorResized(sender, args)
  {
    args.editor = sender;
    pThis.EditorResized.fireHandlers(args);
  }


  function onEditorBlured(sender, args)
  {
    args.editor = sender;
    pThis.EditorBlured.fireHandlers(args);
  }


  function getPageGlobalStyles (formatingIFrame)
  {
    let inElement = formatingIFrame.document.getElementById('idPrimaryContentBlock1ContentHolder'),
        inStyles;

    if (inElement)
    {
      inStyles = (isIE) ? inElement.currentStyle : formatingIFrame.getComputedStyle(inElement, null);

      if (inStyles)
      {
        if (!pThis.pageGlobalStyles)
        {
          pThis.pageGlobalStyles = {};
        }

        if (!pThis.pageGlobalStyles['idPrimaryContentBlock1ContentHolder'])
        {
          pThis.pageGlobalStyles['idPrimaryContentBlock1ContentHolder'] = {};
        }

        pThis.pageGlobalStyles['idPrimaryContentBlock1ContentHolder'].backgroundColor = inStyles['backgroundColor'];
        pThis.pageGlobalStyles['idPrimaryContentBlock1ContentHolder'].backgroundImage = inStyles['backgroundImage'];
        pThis.pageGlobalStyles['idPrimaryContentBlock1ContentHolder'].backgroundPosition = inStyles['backgroundPosition'];
        pThis.pageGlobalStyles['idPrimaryContentBlock1ContentHolder'].backgroundRepeat = inStyles['backgroundRepeat'];
      }
    }
  }


  function setWindowVariables (targetWindow)
  {
    let variableWindow = targetWindow || getRuntimeDefaultWindow();

    winLocationHref    = variableWindow.location.href;
    winLocationDomain  = winLocationHref.replace(/^(https?\:\/\/[^\/\:]+)(\/|\:)?.*$/i, '$1');
  }


  function validateBeforePublish ()
  {
    for (let i = 0; i < pThis.pEditors.length; i++)
    {
      pThis.pEditors[i].editor.validateBeforePublish();
    }
  }


  function saveAllEditData ()
  {
    let i, r,
        ret = null,
        winContent = getRuntimeDefaultWindow();

    for (i = 0; i < pThis.pEditors.length; i++)
    {
      if (winContent.document.getElementById(pThis.pEditors[i].idOut))
      {
        r = pThis.pEditors[i].editor.saveData();

        if (r != false)
        {
          ret = r;
        }
      }
    }

    return ret;
  }


  function safeSaveData ()
  {
    let i, j,
        meIndex,
        outContainer,
        contentIFrameName,
        contentIFrame,
        beginMarker,
        endMarker,
        rawContent,
        winContent = getRuntimeDefaultWindow();

    for (i = 0; i < pThis.pEditors.length; i++)
    {
      outContainer = winContent.document.getElementById(pThis.pEditors[i].idOut + '_Raw');

      if (outContainer)
      {
        if (pThis.pEditors[i].type === 'SingleEditor' || !pThis.pEditors[i].editor.multiEditorMode)
        {
          rawContent = '###!SAFESAVE_SINGLE_EDITOR!###';
          contentIFrameName = (pThis.pEditors[i].type === 'SingleEditor') ? pThis.pEditors[i].contentIFrameName : pThis.pEditors[i].editor.singleEditor.contentIFrameName;
          saveIFrameHTML();
        }
        else
        {
          rawContent = '###!SAFESAVE_MULTI_EDITOR!###';

          let pageLayoutTemplate = winContent.document.getElementById(pThis.pEditors[i].idIn);

          if (pageLayoutTemplate && pageLayoutTemplate.innerHTML != null)
          {
            rawContent += pageLayoutTemplate.innerHTML;

            for (meIndex = 0; meIndex < pThis.pEditors[i].editor.editorsCounter; meIndex++)
            {
              rawContent += '###!SAFESAVE_SEPARATOR!###';
              contentIFrameName = pThis.pEditors[i].editor.editorList[meIndex].contentIFrameName;
              saveIFrameHTML();
            }
          }
          else
          {
            rawContent += '###!SAFESAVE_TEMPLATE_IS_NULL!###';
          }
        }

        outContainer.value = rawContent;
      }
    }



    function saveIFrameHTML ()
    {
      contentIFrame = null;

      for (j = 0; j < winContent.frames.length; j++)
      {
        try
        {
          if (winContent.frames[j].name === contentIFrameName)
          {
            contentIFrame = winContent.frames[j];
            break;
          }
        }
        catch (err)
        {
          continue;
        }
      }

      if (contentIFrame)
      {
        if (contentIFrame.document)
        {
          if (contentIFrame.document.body)
          {
            if (contentIFrame.document.body.innerHTML != null)
            {
              beginMarker = contentIFrame.document.createElement('INPUT');
              beginMarker.type = 'hidden';
              beginMarker.name = 'sysEditor_SafeSaveContentBegin';
              endMarker = contentIFrame.document.createElement('INPUT');
              endMarker.type = 'hidden';
              endMarker.name = 'sysEditor_SafeSaveContentEnd';

              if (isIE)
              {
                beginMarker.style.cssText = endMarker.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;z-index:0;overflow:hidden;visibility:hidden;border:0;font-size:0;';
              }

              if (contentIFrame.document.body.firstChild)
              {
                contentIFrame.document.body.insertBefore(beginMarker, contentIFrame.document.body.firstChild);
                contentIFrame.document.body.appendChild(endMarker);
              }
              else
              {
                contentIFrame.document.body.appendChild(beginMarker);
                contentIFrame.document.body.appendChild(endMarker);
              }

              rawContent += contentIFrame.document.body.innerHTML;
            }
            else
            {
              rawContent += '###!SAFESAVE_INNERHTML_IS_NULL!###';
            }
          }
          else
          {
            rawContent += '###!SAFESAVE_BODY_IS_NULL!###';
          }
        }
        else
        {
          rawContent += '###!SAFESAVE_DOCUMENT_IS_NULL!###';
        }
      }
      else
      {
        rawContent += (j < winContent.frames.length) ? '###!SAFESAVE_IFRAME_IS_NULL!###' : '###!SAFESAVE_IFRAME_NOT_FOUND!###';
      }
    }
  }


  function getEditorById (editorId)
  {
    for (let i = 0; i < pThis.pEditors.length; i++)
    {
      if (pThis.pEditors[i].id === editorId)
      {
        return pThis.pEditors[i].editor;
      }
    }

    return null;
  }


  function initAllEditors (viewEditMode)
  {
    viewEditMode = (viewEditMode && viewEditMode.toLowerCase() === 'view') ? 'view' : 'edit';
    isEditorsInViewMode = viewEditMode === 'view';

    for (let i = 0; i < pThis.pEditors.length; i++)
    {
      pThis.pEditors[i].editor.initEditor(viewEditMode);
    }
  }


  function getIsEditorsInViewMode ()
  {
    return isEditorsInViewMode;
  }


  function setIsEditorsInViewMode (viewMode)
  {
    isEditorsInViewMode = viewMode;
  }


  function validateEmptyData (postBackFunction)
  {
    if (saveAllEditData())
    {
      postBackFunction();
    }
    else
    {
      if (saveAllDataAttempts > 0)
      {
        if (saveAllDataAttemptTimeout)
        {
          clearTimeout(saveAllDataAttemptTimeout);
        }

        saveAllDataAttemptTimeout = setTimeout(function() { validateEmptyData(postBackFunction); }, 1000);
        saveAllDataAttempts--;
      }
      else
      {
        postBackFunction();
      }
    }
  }

  function hookupPageValidation (targetWindow)
  {
    const variableWindow = targetWindow || getRuntimeDefaultWindow();

    BEditor.domHandlers.addHandler(variableWindow, 'unload', unloadPage);

    if (variableWindow.Page_ClientValidate)
    {
      if (!pThis.validation_OriginalPageClientValidate)
      {
        pThis.validation_OriginalPageClientValidate = variableWindow.Page_ClientValidate;
        variableWindow.Page_ClientValidate = function(validationGroup)
        {
          saveAllEditData();
          return pThis.validation_OriginalPageClientValidate(validationGroup);
        }
      }
    }
  }


  function unloadAllEditors ()
  {
    if (topWin.contentarea)
    {
      BEditor.domHandlers.removeHandler(topWin.contentarea, 'unload', unloadAllEditors);
    }

    BEditor.domHandlers.removeHandler(window, 'unload', unloadAllEditors);

    for (let i = 0; i < pThis.pEditors.length; i++)
    {
      if (pThis.pEditors[i].editor)
      {
        if (pThis.pEditors[i].editor.isReactComponentEditor()) { continue; }
        pThis.pEditors[i].editor.unload();
      }
    }

    BEditor.ToolbarsManager.hideToolbar();
    BEditor.ToolbarsManager.isToolbarWaitingShow = false;
  }


  function unloadPage (targetWindow)
  {
    BEditor.domHandlers.removeHandler((targetWindow || getRuntimeDefaultWindow()), 'unload', unloadPage);
    pThis.validation_OriginalPageClientValidate = null;

    pThis.EditorStarted.disposeHandlers();
    pThis.EditorStopped.disposeHandlers();
    pThis.EditorResized.disposeHandlers();
  }



  //============================================================================================

  pThis.createPageShadingContainer = createPageShadingContainer;
  pThis.showPageShadingContainer = showPageShadingContainer;
  pThis.hidePageShadingContainer = hidePageShadingContainer;
  pThis.setPageShadingContainerSize = setPageShadingContainerSize;


  let pageShadingContainer,
      pageShadingWaitMessage,
      pageShadingWaitMessageText,
      pageShadingContainerState = false,
      realShadingContainerState = false,
      isPageShadingContainerHideTM = false,
      isPrimaryShading = false;

  function createPageShadingContainer ()
  {
    const waitMessage = 'Please wait...';
    const waitMessageImgURL = BEditor.environment.statRes + 'Images/shading-preloader.gif?' + BEditor.environment.version; //'/Admin/html_res/images/async-load-progress-01.gif';
    const waitMessageHTML = '<div id="idEditorPageShadingWaitMessage" style="display: none; position: absolute; width: 350px; text-align: center;">' + ((waitMessageImgURL) ? '<img src="' + waitMessageImgURL + '" border="0" width="100" height="100"><br>&nbsp;&nbsp;' : '') + '<span id="idEditorPageShadingWaitMessageText" style="font-size: 14px;">' + ((waitMessage) ? waitMessage : '') + '</span>' + '</div>';
    const pageShadingContainerHtml = '<div id="idEditorPageShadingContainer" style="position: absolute; left: -3700px; top: -3700px; width: 1px; height: 1px; z-index: 7337; overflow: hidden; visibility: hidden; background-color: #FFFFFF; opacity: 0.73;">' + waitMessageHTML + '</div>';
    const pageShadingHolder = document.createElement('SPAN');

    pageShadingHolder.innerHTML = pageShadingContainerHtml;
    document.body.appendChild(pageShadingHolder);
    pageShadingContainer = document.getElementById('idEditorPageShadingContainer');
    pageShadingWaitMessage = document.getElementById('idEditorPageShadingWaitMessage');
    pageShadingWaitMessageText = document.getElementById('idEditorPageShadingWaitMessageText');
  }


  function showPageShadingContainer (showWaitMessage, newWaitMessageText, tm, isPrimary)
  {
    isPrimaryShading = !!isPrimary;

    if (!pageShadingContainerState)
    {
      pageShadingContainerState = true;
      realShadingContainerState = true;
      pageShadingWaitMessageText.innerHTML = (newWaitMessageText == null) ? 'Please wait...' : newWaitMessageText;
      pageShadingWaitMessage.style.display = (showWaitMessage) ? 'block' : 'none';
      pageShadingContainer.style.visibility = 'visible';
      setTimeout(function() { setPageShadingContainerSize(showWaitMessage); }, 10);
      BEditor.domHandlers.addHandler(window, 'resize', setPageShadingContainerSize);

      if (tm)
      {
        isPageShadingContainerHideTM = true;
        setTimeout(function () { isPageShadingContainerHideTM = false; }, tm);
      }
    }
  }


  function hidePageShadingContainer (isPrimary)
  {
    if (isPrimaryShading && isPrimary)
    {
      isPrimaryShading = false;
    }

    if (isPageShadingContainerHideTM)
    {
      setTimeout(hidePageShadingContainer, 37);
      return true;
    }

    realShadingContainerState = false;

    if (pageShadingContainerState && !isPrimaryShading)
    {
      pageShadingContainerState = false;
      BEditor.domHandlers.removeHandler(window, 'resize', setPageShadingContainerSize);
      pageShadingContainer.style.visibility = 'hidden';
      pageShadingContainer.style.left = '-3700px';
      pageShadingContainer.style.top = '-3700px';
      pageShadingContainer.style.width = '1px';
      pageShadingContainer.style.height = '1px';
      pageShadingContainer.style.overflow = 'hidden';
      pageShadingWaitMessage.style.display = 'none';
    }
  }


  function setPageShadingContainerSize (showWaitMessage)
  {
    pageShadingContainer.style.left = '0px';
    pageShadingContainer.style.top = '0px';
    pageShadingContainer.style.width = BEditor.window.getScrollWidth() + 'px';
    pageShadingContainer.style.height = BEditor.window.getScrollHeight() + 'px';

    if (showWaitMessage || pageShadingWaitMessage.style.display === 'block')
    {
      pageShadingWaitMessage.style.left = Math.floor((BEditor.window.getInnerWidth() - pageShadingWaitMessage.offsetWidth) / 2) + 'px';
      pageShadingWaitMessage.style.top = Math.floor((BEditor.window.getInnerHeight() - pageShadingWaitMessage.offsetHeight) / 2) + 'px';
    }
  }


  BEditor.domHandlers.addPageParsedHandler(createPageShadingContainer);
}


//export default { EditorsManager: pThis };
